import { ModalId } from '../../../enums/modalId'
import { useWarningModals } from '../../../hooks/useWarningModals'
import { VATConfirmationModal } from '../elements/VATConfirmationModal'

export const useVatConfirmationWarningModal = () => {
  return useWarningModals({
    warnings: {
      [ModalId.VATConfirmationModal]: 'isVatExempted',
    },
    modals: <VATConfirmationModal id={ModalId.VATConfirmationModal} />,
  })
}
